import SectionTitle from "@/components/ui/section-title";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import ImageCard from "../../ui/image_card/imgCard";

import SwiperPagination from "@/components/ui/swiper/swiper-pagination";

import { MEDIA_BASE_URL } from "@/utils/api";

const Application = ({ productDetails, applicationData }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  return (
    <section className="md:flex md:flex-wrap items-center container justify-between">
      <div className="md:w-[45%] mb-5 lg:mb-0">
        {productDetails?.inner_image?.trim() ? (
          <Image
            src={`${mediaBaseUrl}${productDetails.inner_image}`}
            width={1200}
            height={900}
            alt={"Features"}
          />
        ) : null}
      </div>

      <div className="md:w-[48%] mb-5 lg:mb-0">
        <SectionTitle customClass={"mb-4 lg:mb-[1vw]"} title={"Features"} />
        <p>{productDetails?.application_description}</p>

        <Swiper
          slidesPerView={1}
          spaceBetween={25}
          speed={2000}
          loop={true}
          pagination={{
            clickable: true,
            el: ".application-pagination",
          }}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          modules={[Pagination]}
          breakpoints={{
            0: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
          className="h-full flex"
        >
          {applicationData.map((item, i) => (
            <SwiperSlide key={i} className="h-full">
              <ImageCard
                imgSrc={`${mediaBaseUrl}${item.image}`}
                title={item.name}
                imgClass={`h-[43px] lg:h-[3.1vw] w-auto`}
                customClass={`text-center font-secondary text-black`}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <SwiperPagination
          customClass={"application-pagination "}
        />
      </div>
    </section>
  );
};

export default Application;
